import clsx from 'clsx';
import LifepointsLogo from 'components/assets/lifepoints-logo.svg';
import Button from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';
import Overlay from 'components/atoms/Overlay/Overlay';
import Txt from 'components/atoms/Txt/Txt';
import { useRouter } from 'next/router';
import classes from './BarcModal.module.scss';

export type Props = {
  onClose: () => void;
};

export default function BarcSavedModal({ onClose }: Props) {
  const router = useRouter();

  function handleOpenDataUsage() {
    router.push('/member/data-preferences');
  }

  return (
    <Overlay onBackgroundInteraction={onClose}>
      <Card className={clsx(classes.container, classes.savedModal)}>
        <Button buttonType="text" className={classes.closeButton} onClick={onClose}>
          ×
        </Button>
        <LifepointsLogo alt="Lifepoints Logo" width={151} height={31} className={classes.logo} />
        <Heading level={3} className={classes.header}>
          Thank You
        </Heading>
        <Txt component="p" className={classes.intro}>
          Your cookie preferences have been updated
        </Txt>
        <Txt component="p">
          To ensure no survey opportunities ever pass you by, you can also opt in to (or out of)
          Advertising Research studies run with publishers on the ‘Data Usage and Preferences’ page.
        </Txt>
        <Txt component="p">
          Opt in to these research programs and maximise your chances to earn with LifePoints. Shall
          we do that now?
        </Txt>
        <Button
          buttonType="primary"
          buttonSize="large"
          className={classes.ctaButton}
          onClick={handleOpenDataUsage}
          onAuxClick={handleOpenDataUsage}
        >
          <Txt>Open Data Usage and Preferences</Txt>
        </Button>
      </Card>
    </Overlay>
  );
}
